const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/AppBar/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        ButtonBack: 'zurück',
        Logout: 'Abmelden',
        BackToStart: 'Zurück zum Startbildschirm',
        Notification: 'Benachrichtigung',
        Close: 'Schliessen',
        installationProcess: 'Installationsprozess',
        iosAlert:
            'Um Patientenportal zu installieren, tippen Sie auf das Symbol „Teilen“ und wählen Sie „Zum Startbildschirm hinzufügen“.',
    },
    __RELATIVE_SOURCE_FILE__
);
